import en from '../l10n/translations.en-US.json';

const translations = { en };

export default translations;
